import { NextRouter } from 'next/router';
import { PUBLIC_ROUTES } from '../config/guard-config';

export const isPathInRoutes = (pathname: string, routes: readonly string[]): boolean =>
  routes.some((route) => pathname.startsWith(route));

export const shouldRedirect = (
  pathname: string,
  freeRoutes: readonly string[],
  isAuthenticated: boolean
): boolean => {
  const isPublicRoute = isPathInRoutes(pathname, PUBLIC_ROUTES);
  const isFreeRoute = isPathInRoutes(pathname, freeRoutes);

  return !isPublicRoute && !isFreeRoute && !isAuthenticated;
};

export const redirectToRoute = async (
  router: NextRouter,
  route: string,
  currentPath: string
): Promise<boolean> => {
  if (currentPath === route) return false;
  try {
    return await router.push(route);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Navigation failed:', error);
    return false;
  }
};
